/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createSelector } from '@ngrx/store';

import { selectCompareState } from '@cdba/core/store/reducers';
import { Calculation, SchaefflerBomIdentifier } from '@cdba/shared/models';

import { CompareState } from '../../reducers/compare.reducer';

export const getBomIdentifierForSelectedCalculation = (props: {
  index: number;
}) =>
  createSelector(
    selectCompareState,
    (state: CompareState): SchaefflerBomIdentifier => {
      const calculation = state[props.index]?.calculations?.selected;

      if (calculation) {
        const {
          costingDate,
          costingNumber,
          costingType,
          version,
          enteredManually,
          referenceObject,
          valuationVariant,
        } = calculation;

        return {
          costingDate,
          costingNumber,
          costingType,
          version,
          enteredManually,
          referenceObject,
          valuationVariant,
        };
      }

      return undefined;
    }
  );

export const getCalculations = (props: { index: number }) =>
  createSelector(
    selectCompareState,
    (state: CompareState): Calculation[] =>
      state[props.index]?.calculations?.items
  );

export const getCalculationsLoading = (props: { index: number }) =>
  createSelector(
    selectCompareState,
    (state: CompareState) => state[props.index]?.calculations?.loading
  );

export const getCalculationsError = (props: { index: number }) =>
  createSelector(
    selectCompareState,
    (state: CompareState) => state[props.index]?.calculations?.errorMessage
  );

export const getSelectedCalculationNodeId = (props: { index: number }) =>
  createSelector(selectCompareState, (state: CompareState): string[] =>
    state[props.index]?.calculations?.selectedNodeId
      ? [state[props.index].calculations.selectedNodeId]
      : undefined
  );

export const getSelectedCalculation = (props: { index: number }) =>
  createSelector(
    selectCompareState,
    (state: CompareState): Calculation =>
      state[props.index]?.calculations?.selected
  );

export const getSelectedCalculations = createSelector(
  selectCompareState,
  (state: CompareState): Calculation[] => [
    state[0]?.calculations?.selected,
    state[1]?.calculations?.selected,
  ]
);
